import React from 'react';
import ReactDOM from 'react-dom/client';

// HANYA IMPORT INI (index.css sudah include semua)
import './index.css';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);